<div class="home-container">
  <div class="home-header">
    <dsy-heading class="home-header__title" level="h2" level-size="3xl">Ops Stream</dsy-heading>
    <dsy-tabs [centered]="false" [variant]="'browsing'" [tabsToRender]="tabs" density="compact" [selectedTabIndex]="tabsStore.selectedTabSignal()"> </dsy-tabs>
  </div>
  <div class="home-body">
    <div class="home-body__content">
      <router-outlet />
    </div>
  </div>
</div>
